import request from '../request'

export function fetchDetail (id) {
  return request({
    url: '/app/customer/getAgreementOne',
    params: {
      id
    }
  })
}
